import { useStaticQuery, graphql } from 'gatsby'
import makeSlugForContentfulPost from "../../lib/makeSlugForContentfulPost";
import { PRESS } from "../../lib/collectionNames";

export const usePress = () => {
  const data = useStaticQuery(graphql`
    query {
      allData: allResource(
        filter: { collection: { eq: "press" } }
        sort: { order: DESC, fields: publishedDate }
      ) {
        nodes {
          id
          slug
          publishedDate(formatString: "MMMM D YYYY")
          data {
            title
            thumbnail
            abstract
          }
        }
      }
      allContentfulPress: allContentfulPress(
        sort: { order: DESC, fields: publishedDate },
        filter: { title: { ne: "Dummy" } }
      ) {
          nodes {
            id
            slug
            publishedDate(formatString: "MMMM D YYYY")
            heading
            subHeading
            thumbnailImage {
              url
            }
            thumbnail{
              file{
                url
              }
            }
          }
      }
    }
  `)

  const { allData: localJSONData, allContentfulPress: allContentfulData } = data;

  const localJSONCards = localJSONData.nodes.map(resource => ({
    id: resource.id,
    slug: `${resource.slug}/`,
    thumbnail: resource.data.thumbnail,
    publishedDate: resource.publishedDate,
    title: resource.data.title,
    abstract: resource.data.abstract,
  }))

  const contentfulCards = allContentfulData.nodes.map(resource => {
    const slug = makeSlugForContentfulPost(resource, PRESS);

    return ({
      id: resource.id,
      slug: `${slug}/`,
      thumbnail: resource.thumbnailImage ? resource.thumbnailImage[0].url : "https:" + resource.thumbnail.file.url,
      publishedDate: resource.publishedDate,
      title: resource.heading,
      abstract: resource.subHeading,
    });
  })

  const allCards = [...contentfulCards, ...localJSONCards];

  return allCards
}

export default usePress
